import { useConnectionStore } from '~/store/connection';

export default defineNuxtRouteMiddleware(() => {
  if (process.client) {
    const store = useConnectionStore();
    store.getConnection();
  }
});
